import React, { Component, Fragment } from 'react'
import { Checkbox as CheckboxIcon } from 'app/assets/icons'
import styled from 'styled-components'

type Props = {
    name: string,
    checked?: boolean,
    color?: string,
    checkedColor?: string,
    size?: number,
    className?: string,
    handleChange: () => void
}

type State = {
    checked: boolean
}

class Checkbox extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            checked: this.props.checked || false
        }
    }

    handleClick = () => {
        const checked = !this.state.checked
        this.setState({
            checked
        })
    }

    render() {
        const { name, handleChange, checked, ...otherProps } = this.props
        return (
            <Fragment>
                <StyledInput
                    type="checkbox"
                    name={name}
                    onChange={handleChange}
                    checked={checked}
                />
                <CheckboxIcon
                    checked={checked}
                    onClick={this.handleClick}
                    {...otherProps}
                />
            </Fragment>
        )
    }
}

const StyledInput = styled.input`
    display: none;
`

export { Checkbox }
